import { memo as e, useRef as n, useState as t, useLayoutEffect as i, createElement as o, forwardRef as a, useCallback as l, useImperativeHandle as r, useMemo as d } from "react";

import { jsx as s, jsxs as p, Fragment as c } from "react/jsx-runtime";

import m from "../../utils/classNames/index.js";

import { useSyncExternalStore as u } from "use-sync-external-store/shim";

import { useFloating as h, offset as g, flip as f, size as b, shift as x, autoUpdate as O, FloatingPortal as v } from "@floating-ui/react";

import w from "./useSelect.js";

import y from "@ui-components-3/icons/lib/solid/AngleDown";

import I from "@ui-components-3/icons/lib/solid/AngleUp";

import N from "@ui-components-3/icons/lib/solid/Xmark";

import { INPUT_VARIANT_CLASSES as E } from "../../constants/index.js";

import H from "../../hooks/useId/index.js";

import S from "../Input/index.js";

import P from "../Loading/index.js";

/*
    TODO:
        combobox may be a div; label for works only with inputs, so div is not focused
*/ const A = [], C = () => null, j = (e, n) => {
    const t = l((() => e.filterValue + "_" + e.highlightedOptionIndex + "_" + e.opened + "_" + e.disabled + "_" + e.clearable + "_" + e.selectedOptions.valueHash), []);
    u(e.on, t, t), r(n, (() => e.inputElement));
}, M = (e, n, t) => {
    const i = l((() => (e.isOptionDisabled(n, t) ? 1 : e.highlightedOptionIndex === t ? 2 : 0) | (e.selectedOptions.has(n) ? 4 : 0)), [ n, t ]);
    return u(e.on, i, i);
}, V = e((({option: e, components: n, model: t, index: i, className: o, ...a}) => {
    const l = M(t, e, i), r = e === t.noneOption && "string" == typeof e ? e : t.getOptionLabel(e);
    return s("li", {
        ...a,
        role: "option",
        "aria-disabled": 1 & l ? "true" : void 0,
        "aria-selected": 1 & l ? void 0 : 2 & l ? "true" : "false",
        className: m("p-xs", o, 4 & l ? "font-semibold" : "", 2 & l ? "bg-neutral-100 outline outline-2 -outline-offset-2 outline-[#0F8FFF]" : 1 & l ? "text-neutral-400" : ""),
        children: r
    });
})), D = e((({model: e, className: t, ...i}) => {
    const o = n().current ||= () => e.disabled, a = u(e.on, o, o);
    return s("button", {
        ...i,
        ...e.clearEvents,
        type: "button",
        disabled: a,
        tabIndex: a ? void 0 : -1,
        className: m("btn-neutral-borderless disabled:bg-inherit", t),
        "aria-label": "Clear selection",
        children: s(N, {
            "aria-hidden": "true"
        })
    });
})), L = e((({model: e, className: t, ...i}) => {
    const o = n().current ||= () => e.opened + "_" + e.disabled;
    return u(e.on, o, o), s("button", {
        ...i,
        ...e.arrowEvents,
        type: "button",
        disabled: e.disabled,
        tabIndex: e.disabled ? void 0 : -1,
        className: m("btn-neutral-borderless disabled:bg-inherit", t),
        children: e.opened ? s(I, {
            "aria-hidden": "true"
        }) : s(y, {
            "aria-hidden": "true"
        })
    });
})), _ = e((({model: e, components: o, className: a, variant: l, getOptionProps: r}) => {
    const d = n().current ||= () => e.opened + "_" + e.multiple, [p, c] = t(!1);
    u(e.on, d, d);
    const {x: v, y: w, refs: y, strategy: I, middlewareData: N} = h({
        open: e.opened,
        onOpenChange: n => e.toggle(n),
        whileElementsMounted: O,
        placement: p ? "right" : "bottom",
        strategy: "fixed",
        middleware: [ {
            /**
                 * We prefer bottom placement w/ flip strat.. revert to top if more space is available than bottom.
                 * However, when the space at both ends drops beneath 166px, we force side placement with same flip strat for left/right.
                 */
            name: "allowSidePlacement",
            async fn(e) {
                const n = e.rects.reference.y > 166, t = e.rects.reference.y + e.rects.reference.height - window.innerHeight < -166, i = window.innerWidth - (e.rects.reference.x + e.rects.reference.width), o = e.rects.reference.x;
                return {
                    data: {
                        /* Side Placement only allowed when less than 150px above & below AND must be atleast 200px available on ONE side */
                        changePlacement: !n && !t && (i > 200 || o > 200)
                    }
                };
            }
        }, g(16), f(), b({
            apply({rects: e, elements: n, availableHeight: t}) {
                const i = e.reference.y > 166, o = e.reference.y + e.reference.height - window.innerHeight < -166, a = o ? t - 16 : i ? e.reference.y - 32 : // these cases only apply to sidePlacement
                e.reference.height > window.innerHeight ? window.innerHeight - 32 : e.reference.height - 32, l = 2 * e.reference.width, r = i || o ? e.reference.width : Math.max(window.innerWidth - (e.reference.x + e.reference.width), // space to the right of the reference
                e.reference.x) - 32;
                Object.assign(n.floating.style, {
                    ...r > l ? {
                        maxWidth: `${l}px`
                    } : {
                        minWidth: `${r}px`
                    },
                    maxHeight: `${a}px`
                });
            }
        }), x() ]
    });
    i((() => {
        c(N.allowSidePlacement?.changePlacement);
    }), [ N.allowSidePlacement?.changePlacement ]);
    const H = e.outerElement || e.inputElement;
    /* whole ul must be rendered because aria-controls must point to valid html element */
    return i((() => {
        y.setReference(H);
    }), [ H ]), s("ul", {
        role: "listbox",
        "aria-multiselectable": e.multiple ? "true" : "false",
        id: e.menuId,
        onMouseLeave: e.clearHighlight,
        style: {
            position: I,
            top: w ?? 0,
            left: v ?? 0
        },
        "aria-hidden": e.opened ? "false" : "true",
        className: e.opened ? m("z-[10000] list-none overflow-auto rounded-xl bg-white", l && l in E ? E[l] : "input-focused", a) : "hidden",
        ref: y.setFloating,
        children: e.opened ? s(q, {
            model: e,
            components: o,
            getOptionProps: r
        }) : null
    });
})), q = e((({model: e, getOptionProps: t, components: i}) => {
    const a = n().current ||= () => e.loading ? A : e.filteredOptions, l = u(e.on, a, a);
    return p(c, {
        children: [ l === A ? s("li", {
            className: "p-xs",
            children: s(i.OptionsLoading, {})
        }) : l.length ? s(c, {
            children: l.map(((n, a) => o(i.Option, {
                ...t(a),
                ...e.optionEvents(n, a),
                id: e.getOptionId(a),
                key: e.getOptionKey(n, a),
                model: e,
                components: i,
                option: n,
                index: a
            })))
        }) : s("li", {
            className: "p-xs",
            children: s(i.OptionsPlaceholder, {})
        }), !!i.OptionsSuffix && s("li", {
            children: s(i.OptionsSuffix, {})
        }) ]
    });
})), W = a((({model: e, components: n, className: t, ...i}, o) => (j(e, o), s(S, {
    ...i,
    ...e.handlerEvents,
    ...e.inputEvents,
    id: e.id,
    disabled: e.disabled,
    role: "combobox",
    "aria-expanded": e.opened ? "true" : "false",
    autoComplete: "off",
    "aria-controls": e.menuId,
    "aria-activedescendant": -1 === e.highlightedOptionIndex ? void 0 : e.getOptionId(e.highlightedOptionIndex),
    className: t,
    ref: e.setInputElement,
    suffix: s("span", {
        className: "gap-s inline-flex items-center",
        children: s(n.Arrow, {
            model: e
        })
    }),
    value: e.filterValue
})))), F = a((({model: e, components: n, className: t, variant: i, required: o, ...a}, l) => (j(e, l), 
p("div", {
    tabIndex: e.disabled ? void 0 : 0,
    ...a,
    ...e.handlerEvents,
    id: e.id,
    ref: e.setInputElement,
    "aria-disabled": e.disabled,
    "aria-required": o ? "true" : "false",
    "aria-invalid": "error" === i ? "true" : "false",
    "aria-controls": e.menuId,
    "aria-expanded": e.opened ? "true" : "false",
    "aria-activedescendant": -1 === e.highlightedOptionIndex ? void 0 : e.getOptionId(e.highlightedOptionIndex),
    role: "combobox",
    className: m("input gap-s flex items-center justify-between", e.disabled ? "input-disabled" : "", i && i in E ? E[i] : "", t),
    children: [ s("span", {
        children: e.filterValue
    }), s("span", {
        className: "gap-s inline-flex items-center",
        children: s(n.Arrow, {
            model: e
        })
    }) ]
})))), K = e((({model: e, option: n, index: t, components: i, ...o}) => p("div", {
    className: "py-xxs px-s focus-outline-thin-dark inline-flex items-center gap-[10px] rounded-full border border-neutral-300 bg-neutral-200 text-neutral-800",
    tabIndex: e.disabled ? void 0 : -1,
    "data-option-index": t,
    ...o,
    ...e.chipEvents,
    children: [ e.getOptionLabel(n), e.disabled ? null : s("button", {
        ...e.chipClearButtonEvents(n),
        type: "button",
        tabIndex: -1,
        className: "cursor-pointer rounded-full bg-neutral-300 text-neutral-500",
        "aria-label": "Deselect option",
        children: s(N, {
            "aria-hidden": "true",
            className: "w-s h-s p-[3px]"
        })
    }) ]
}))), k = a((({model: e, components: n, className: t, variant: i, required: o, ...a}, l) => (j(e, l), 
p("div", {
    tabIndex: e.disabled ? void 0 : 0,
    ...a,
    ...e.handlerEvents,
    id: e.id,
    "aria-required": o ? "true" : "false",
    "aria-disabled": e.disabled,
    "aria-invalid": "error" === i ? "true" : "false",
    "aria-controls": e.menuId,
    "aria-expanded": e.opened ? "true" : "false",
    "aria-activedescendant": -1 === e.highlightedOptionIndex ? void 0 : e.getOptionId(e.highlightedOptionIndex),
    role: "combobox",
    className: m(
    // py-xs to avoid stretch because of chip height
    "input gap-s py-xs flex items-center", e.disabled ? "input-disabled" : "", i && i in E ? E[i] : "", t),
    ref: e.setInputElement,
    children: [ s("div", {
        className: "gap-xs flex grow flex-wrap items-center",
        children: e.selectedOptions.map(((t, i) => s(n.Chip, {
            index: i,
            model: e,
            option: t,
            components: n
        }, e.getOptionKey(t, i))))
    }), s("input", {
        type: "hidden"
    }), s(n.Arrow, {
        model: e
    }) ]
})))), B = a((({model: e, components: n, className: t, variant: i, required: o, ...a}, l) => (j(e, l), 
p("div", {
    ...a,
    onPointerDown: n => {
        n.target.hasAttribute("data-f") && (
        // without this blur gets raised
        n.preventDefault(), e.inputElement?.focus());
    },
    "data-f": !0,
    ref: e.setOuterElement,
    className: m(
    // py-xs to avoid stretch because of chip height
    "input gap-s py-xs flex items-center", i && i in E ? E[i] : "", t),
    children: [ p("div", {
        "data-f": !0,
        className: "gap-xs flex grow flex-wrap items-center",
        children: [ e.selectedOptions.map(((t, i) => s(n.Chip, {
            index: i,
            model: e,
            option: t,
            components: n
        }, e.getOptionKey(t, i)))), s("input", {
            ...e.inputEvents,
            ...e.handlerEvents,
            required: o,
            id: e.id,
            value: e.filterValue,
            placeholder: "Search...",
            ref: e.setInputElement,
            disabled: e.disabled,
            "aria-invalid": "error" === i ? "true" : "false",
            "aria-controls": e.menuId,
            "aria-expanded": e.opened ? "true" : "false",
            "aria-activedescendant": -1 === e.highlightedOptionIndex ? void 0 : e.getOptionId(e.highlightedOptionIndex),
            role: "combobox",
            className: "typography-body-l w-0 min-w-0 grow basis-[3em] text-neutral-700 outline-none"
        }) ]
    }), s(n.Arrow, {
        model: e
    }) ]
})))), $ = {
    OptionsWrapper: _,
    Options: q,
    Option: V,
    Arrow: L,
    Clear: D,
    Chip: K,
    SingleComboboxHandle: W,
    SingleSelectHandle: F,
    MultiComboboxHandle: B,
    MultiSelectHandle: k,
    OptionsPlaceholder: () => s("div", {
        className: "text-center text-neutral-400",
        children: "No Options"
    }),
    OptionsLoading: () => s(P, {
        className: "w-full"
    }),
    OptionsSuffix: () => null
}, z = a((({id: e, options: n, onChange: t, onSearch: i, loading: o, hideArrow: a, rawValueMode: l, value: r, defaultValue: m, components: u, isOptionDisabled: h, getOptionLabel: g, variant: f, getOptionProps: b = () => {}, getOptionKey: x, getOptionValue: O, searchable: y, clearable: I, multiple: N, disabled: E, portal: S, noneOption: P, onBlur: A, isAsyncAutocomplete: j, onHandleEnterPress: M, ...V}, D) => {
    const L = H(e), _ = w(L, {
        options: n,
        clearable: I,
        isOptionDisabled: h,
        getOptionKey: x,
        getOptionValue: O,
        getOptionLabel: g,
        onChange: t,
        onSearch: i,
        loading: o,
        value: r ?? m,
        rawValueMode: l,
        multiple: N,
        disabled: E,
        noneOption: P,
        customOnBlur: A,
        isAsyncAutocomplete: j,
        customOnHandleEnterPress: M
    }), q = d((() => ({
        ...$,
        ...u,
        ...a ? {
            Arrow: C
        } : null
    })), [ u, a ]), W = N ? y ? q.MultiComboboxHandle : q.MultiSelectHandle : y ? q.SingleComboboxHandle : q.SingleSelectHandle, F = s(q.OptionsWrapper, {
        model: _,
        variant: f,
        components: q,
        getOptionProps: b,
        "aria-labelledby": V["aria-labelledby"]
    });
    return p(c, {
        children: [ s(W, {
            ...V,
            variant: f,
            model: _,
            components: q,
            ref: D
        }), S ? s(v, {
            children: F
        }) : F ]
    });
}));

export { z as default, j as useHandleSubscription, M as useOptionStateMaskSubscription };
//# sourceMappingURL=index.js.map
